import { render } from "./ItemSearch.vue?vue&type=template&id=2addaad8"
import script from "./ItemSearch.vue?vue&type=script&lang=js"
export * from "./ItemSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__